<template>
  <nuttrema-layout-west-slide width="30%">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>

    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader v-if="InvitationDetails.fetching"></nuttrema-loader>
        <form-invite-details
           v-else
          :InvitationDetails="InvitationDetails"
          @cancel="onCancelEvent"
          @delete="onDeleteEvent"
          @cancelInvite="cancelInviteEvent"
          @resendInvite="onResendInviteEvent">
        </form-invite-details>
      </template>
    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';
import FormInviteDetails from './form-invite-details';

export default {
  name: 'page-invite-details',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: -1,
    },
  },
  components: {
    FormInviteDetails,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    InvitationDetails() {
      return this.$store.getters.InvitationDetails(this.id);
    },
  },
  methods: {
    ...mapActions([
      'ResendInvitation',
      'CancelInvitation',
      'DeleteInvitation',
    ]),
    onDeleteEvent() {
      return this.DeleteInvitation({ id: this.id })
        .then(() => {
          this.successNotification({ message: 'message.default_success_delete_message', label: 'label.invite' });
          this.onSuccessEvent();
        }).catch(() => {
          this.errorNotification({ message: 'message.default_error_delete_message' });
        });
    },
    cancelInviteEvent() {
      return this.CancelInvitation({ id: this.id })
        .then(() => {
          this.successNotification({ message: 'message.success_invite_canceled' });
          this.onSuccessEvent();
        }).catch(() => {
          this.errorNotification({ message: 'message.error_invite_canceled' });
        });
    },
    onResendInviteEvent() {
      return this.ResendInvitation({ id: this.id })
        .then(() => {
          this.successNotification({ message: 'message.default_success_send_message', label: 'label.invite' });
          this.onSuccessEvent();
        }).catch(() => {
          this.errorNotification({ message: 'message.default_error_send_message', label: 'label.invite' });
        });
    },
  },
  created() {
    this.$store.dispatch('GetInvitationDetails', { id: this.id });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearProgramDetails', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/invitations/details/page-invite-details.vue